function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("rect", {
  width: 59,
  height: 59,
  fill: "#4092D7",
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M5,13 L11,13 L11,19 L5,19 L5,13 Z M13,13 L19,13 L19,19 L13,19 L13,13 Z M5,21 L11,21 L11,27 L5,27 L5,21 Z M13,21 L19,21 L19,27 L13,27 L13,21 Z M21,21 L27,21 L27,27 L21,27 L21,21 Z M5,5 L11,5 L11,11 L5,11 L5,5 Z M2,27 L0,27 L0,3.08 C0,1.40076837 1.26271187,0 2.875,0 L29.125,0 C30.7372881,0 32,1.40076837 32,3.08 L32,27 L30,27 L30,3.08 C30,2.46172707 29.5837797,2 29.125,2 L2.875,2 C2.41622031,2 2,2.46172707 2,3.08 L2,27 Z",
  transform: "translate(14 16)"
}));

function SvgIconLagerstyring(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLagerstyring);
export default __webpack_public_path__ + "static/media/icon-lagerstyring.f022b466.svg";
export { ForwardRef as ReactComponent };